// Leftover FE talks to leftover API. A production JWT sitting in ew_token
// (from before that wire) fails leftover GET /auth/me. The old AuthContext
// then logout() with no message and remounts /login empty — "blank Sign In".

export const AUTH_ERROR_KEY = 'ew_auth_error';

export function loginErrorMessage(err) {
  const detail = err?.response?.data?.detail;
  if (typeof detail === 'string' && detail.trim()) return detail;
  if (err?.message === 'Network Error') {
    return 'Could not reach the sign-in server. Check the address and try again.';
  }
  return 'Login failed';
}

export function restoreErrorMessage(err) {
  const detail = err?.response?.data?.detail;
  if (detail === 'Invalid token' || detail === 'Not authenticated'
      || detail === 'Token expired' || detail === 'User not found') {
    return 'That saved sign-in is for a different server. Please sign in again.';
  }
  if (typeof detail === 'string' && detail.trim()) return detail;
  return 'Sign-in session could not be restored. Please sign in again.';
}

export function shouldIgnoreRestore(restoreId, thisRestoreId) {
  return Number(restoreId) !== Number(thisRestoreId);
}

export function readAuthError() {
  try {
    return sessionStorage.getItem(AUTH_ERROR_KEY) || '';
  } catch (_err) {
    return '';
  }
}

export function writeAuthError(message) {
  try {
    if (message) sessionStorage.setItem(AUTH_ERROR_KEY, message);
    else sessionStorage.removeItem(AUTH_ERROR_KEY);
  } catch (_err) {
    /* private mode */
  }
}
